import React from "react";
import { Col, Row } from "react-bootstrap";
import Switch from "react-switch";
import Addons from "../Addons";

const RealPropertyOwned = ({
  state,
  setState,
  handleExtraChange,
  extraField,
  activeTab,
  handleSaveField,
}) => {
  const handleToggle = (value, name) => {
    setState((pre) => ({ ...pre, [name]: value }));
  };
  return (
    <div>
      <section className="view-data">
        <Row className="main-view-email pt-3">
          <Col md={6} className="left-name-data my-2">
            <h6>
              <strong className="">Property Description:</strong>
            </h6>
            <ul className="list-unstyled ps-0 mb-0">
              <li className="d-flex align-items-center  gap-10">
                <div className="left d-flex align-items-center gap-10">
                  <strong className="pe-2">Visible</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "property_description_visible")
                    }
                    checked={state.property_description_visible}
                  />
                </div>
                <div className="right d-flex align-items-center gap-10">
                  <strong className="pe-2">Required</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "property_description_required")
                    }
                    checked={state.property_description_required}
                  />
                </div>
              </li>
            </ul>
          </Col>
          <Col md={6} className="left-name-data my-2">
            <h6>
              <strong className="">Location:</strong>
            </h6>
            <ul className="list-unstyled ps-0 mb-0">
              <li className="d-flex align-items-center  gap-10">
                <div className="left d-flex align-items-center gap-10">
                  <strong className="pe-2">Visible</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "location_visible")
                    }
                    checked={state.location_visible}
                  />
                </div>
                <div className="right d-flex align-items-center gap-10">
                  <strong className="pe-2">Required</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "location_required")
                    }
                    checked={state.location_required}
                  />
                </div>
              </li>
            </ul>
          </Col>
          <Col md={6} className="left-name-data my-2">
            <h6>
              <strong className="">Current fair market value:</strong>
            </h6>
            <ul className="list-unstyled ps-0 mb-0">
              <li className="d-flex align-items-center  gap-10">
                <div className="left d-flex align-items-center gap-10">
                  <strong className="pe-2">Visible</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "current_fair_market_value_visible")
                    }
                    checked={state.current_fair_market_value_visible}
                  />
                </div>
                <div className="right d-flex align-items-center gap-10">
                  <strong className="pe-2">Required</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "current_fair_market_value_required")
                    }
                    checked={state.current_fair_market_value_required}
                  />
                </div>
              </li>
            </ul>
          </Col>
          <Col md={6} className="left-name-data my-2">
            <h6>
              <strong className="">Loan Balance:</strong>
            </h6>
            <ul className="list-unstyled ps-0 mb-0">
              <li className="d-flex align-items-center  gap-10">
                <div className="left d-flex align-items-center gap-10">
                  <strong className="pe-2">Visible</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "loan_balance_visible")
                    }
                    checked={state.loan_balance_visible}
                  />
                </div>
                <div className="right d-flex align-items-center gap-10">
                  <strong className="pe-2">Required</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "loan_balance_required")
                    }
                    checked={state.loan_balance_required}
                  />
                </div>
              </li>
            </ul>
          </Col>
          <Col md={6} className="left-name-data my-2">
            <h6>
              <strong className="">Amount of monthly payment:</strong>
            </h6>
            <ul className="list-unstyled ps-0 mb-0">
              <li className="d-flex align-items-center  gap-10">
                <div className="left d-flex align-items-center gap-10">
                  <strong className="pe-2">Visible</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "amount_of_monthly_payment_visible")
                    }
                    checked={state.amount_of_monthly_payment_visible}
                  />
                </div>
                <div className="right d-flex align-items-center gap-10">
                  <strong className="pe-2">Required</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "amount_of_monthly_payment_required")
                    }
                    checked={state.amount_of_monthly_payment_required}
                  />
                </div>
              </li>
            </ul>
          </Col>
          <Col md={6} className="left-name-data my-2">
            <h6>
              <strong className="">Amount of your equity:</strong>
            </h6>
            <ul className="list-unstyled ps-0 mb-0">
              <li className="d-flex align-items-center  gap-10">
                <div className="left d-flex align-items-center gap-10">
                  <strong className="pe-2">Visible</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "amount_of_your_equity_visible")
                    }
                    checked={state.amount_of_your_equity_visible}
                  />
                </div>
                <div className="right d-flex align-items-center gap-10">
                  <strong className="pe-2">Required</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "amount_of_your_equity_required")
                    }
                    checked={state.amount_of_your_equity_required}
                  />
                </div>
              </li>
            </ul>
          </Col>
          <Col md={6} className="left-name-data my-2">
            <h6>
              <strong className="">Name of lender:</strong>
            </h6>
            <ul className="list-unstyled ps-0 mb-0">
              <li className="d-flex align-items-center  gap-10">
                <div className="left d-flex align-items-center gap-10">
                  <strong className="pe-2">Visible</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "name_of_lender_visible")
                    }
                    checked={state.name_of_lender_visible}
                  />
                </div>
                <div className="right d-flex align-items-center gap-10">
                  <strong className="pe-2">Required</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "name_of_lender_required")
                    }
                    checked={state.name_of_lender_required}
                  />
                </div>
              </li>
            </ul>
          </Col>
          <Col md={6} className="left-name-data my-2">
            <h6>
              <strong className="">Address:</strong>
            </h6>
            <ul className="list-unstyled ps-0 mb-0">
              <li className="d-flex align-items-center  gap-10">
                <div className="left d-flex align-items-center gap-10">
                  <strong className="pe-2">Visible</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) => handleToggle(event, "address_visible")}
                    checked={state.address_visible}
                  />
                </div>
                <div className="right d-flex align-items-center gap-10">
                  <strong className="pe-2">Required</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "address_required")
                    }
                    checked={state.address_required}
                  />
                </div>
              </li>
            </ul>
          </Col>
          <Col md={6} className="left-name-data my-2">
            <h6>
              <strong className="">Account Number:</strong>
            </h6>
            <ul className="list-unstyled ps-0 mb-0">
              <li className="d-flex align-items-center  gap-10">
                <div className="left d-flex align-items-center gap-10">
                  <strong className="pe-2">Visible</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "account_no_visible")
                    }
                    checked={state.account_no_visible}
                  />
                </div>
                <div className="right d-flex align-items-center gap-10">
                  <strong className="pe-2">Required</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "account_no_required")
                    }
                    checked={state.account_no_required}
                  />
                </div>
              </li>
            </ul>
          </Col>

          {extraField &&
            extraField.length > 0 &&
            extraField.map((item, idx) => {
              return (
                <Col md={6} className="left-name-data my-2" key={idx}>
                  <h6>
                    <strong className="text-capitalize">{item.title}:</strong>
                  </h6>
                  <ul className="list-unstyled ps-0 mb-0">
                    <li className="d-flex align-items-center  gap-10">
                      <div className="left d-flex align-items-center gap-10">
                        <strong className="pe-2">Visible</strong>
                        <Switch
                          offColor="#888"
                          onColor="#3363df"
                          onChange={(event) =>
                            handleToggle(
                              event,
                              item.title.toLowerCase().split(" ").join("_") +
                                "_visible"
                            )
                          }
                          checked={
                            state[
                              item.title.toLowerCase().split(" ").join("_") +
                                "_visible"
                            ]
                          }
                        />
                      </div>
                      <div className="right d-flex align-items-center gap-10">
                        <strong className="pe-2">Required</strong>
                        <Switch
                          offColor="#888"
                          onColor="#3363df"
                          onChange={(event) =>
                            handleToggle(
                              event,
                              item.title.toLowerCase().split(" ").join("_") +
                                "_required"
                            )
                          }
                          checked={
                            state[
                              item.title.toLowerCase().split(" ").join("_") +
                                "_required"
                            ]
                          }
                        />
                      </div>
                    </li>
                  </ul>
                </Col>
              );
            })}
        </Row>
      </section>
      <div className="heading-fields-type">
        <h2>Add More Fields in Finance form.</h2>
        <Addons
          handleChange={handleExtraChange}
          data={extraField}
          activeTab={activeTab}
          handleSaveField={handleSaveField}
        />
      </div>
    </div>
  );
};

export default RealPropertyOwned;
